module.exports = __webpack_public_path__ + "static/media/article-image-1.455cf0c8.jpg";